import { Box, Flex, forwardRef, Select, Text, Tooltip } from "@chakra-ui/react";
import { useEffect } from "react";

const TokenSelector = forwardRef(
  ({ txtLabel, selectLabel, options, setSelectedOption, selectedOption, tooltip, ...props }, ref) => {
    // hook for resetting the selected option if the dropdown is empty
    // happens if targetToken && sourceToken, and then targetToken => ""
    useEffect(() => {
      if (options.length === 0 && selectedOption) {
        setSelectedOption("");
      }
    }, [options, selectedOption, setSelectedOption]);

    return (
      <Box ref={ref} {...props}>
        <Flex align="center" justify="space-between">
          <Text fontSize="lg" fontWeight="bold">
            {txtLabel}
          </Text>

          <Tooltip hasArrow bg="red.500" color="white" label={tooltip} fontSize="lg" placement="auto" closeDelay={500}>
            <Text fontSize="xs">ℹ️</Text>
          </Tooltip>
        </Flex>

        <Select
          placeholder={selectLabel}
          variant="flushed"
          mt="0.25em"
          onChange={(e) => setSelectedOption(e.target.value)}
          value={selectedOption}
        >
          {options.map((o) => {
            return (
              <option key={o.tokenxAddress} value={o.tokenxSymbol}>
                &nbsp;&nbsp;{o.tokenxSymbol}
              </option>
            );
          })}
        </Select>
      </Box>
    );
  }
);

export default TokenSelector;
